import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

const POINTS = [
  "All Lab2o products are sold strictly for laboratory research purposes only.",
  "Products are not for human or veterinary use or consumption of any kind.",
  "No medical, therapeutic, diagnostic, or clinical claims are made or implied.",
  "The buyer assumes full responsibility for safe handling, storage, and lawful use in a research setting.",
  "By purchasing, you confirm the products will be used solely as research reagents.",
];

export default function DisclaimerBlock() {
  return (
    <section id="notice" className="bg-slate-950 text-white py-24 sm:py-32 relative overflow-hidden" data-testid="notice-section">
      <span
        aria-hidden
        className="pointer-events-none select-none absolute -left-6 bottom-0 font-chivo font-black text-[18vw] leading-none text-outline-light hidden lg:block"
      >
        NOTICE
      </span>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-plexmono text-[11px] tracking-[0.25em] uppercase text-slate-500 mb-4" data-testid="notice-overline">
            03 — Important Notice
          </p>
          <div className="flex items-start gap-4 mb-10">
            <span className="w-12 h-12 bg-red-600 flex items-center justify-center shrink-0">
              <AlertTriangle className="w-6 h-6 text-white" />
            </span>
            <h2 className="font-chivo font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02]" data-testid="notice-heading">
              For research purposes only.
            </h2>
          </div>

          <p className="text-xl sm:text-2xl font-chivo font-light text-slate-300 max-w-3xl leading-snug mb-12" data-testid="notice-statement">
            Not for human or veterinary use or consumption.
          </p>

          <ul className="grid sm:grid-cols-2 gap-x-12 gap-y-6 max-w-4xl">
            {POINTS.map((p, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.07 }}
                className="flex items-start gap-3 text-sm text-slate-400 leading-relaxed"
                data-testid={`notice-point-${i + 1}`}
              >
                <span className="font-plexmono text-[10px] tracking-widest text-red-500 pt-1 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {p}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
